import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Container } from 'react-bootstrap';

const AdminLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="d-flex">
      <Sidebar collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      <Container
        fluid
        className="pt-4"
        style={{
          marginLeft: sidebarCollapsed ? '60px' : '220px',
          transition: 'margin-left 0.3s ease',
        }}
      >
        {children}
      </Container>
    </div>
  );
};

export default AdminLayout;
